import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import { Button } from "react-bootstrap";
import CustomPagination from "../../components/CustomPagination";
import useLiveDataTableCard from '../../hooks/useLiveDataTableCard';
import { useGetPermitsQuery } from "../../redux/services/PermitService";
import AddCompanyModal from './Add';
import ViewModal from './View';


const PermitsPage = () => {
    const navigate = useNavigate()
    const {
        currentPage,
        perPage,
        q,
        searchQuery,
        setSearchQuery,
        handlePageChange,
        handlePerPageChange,
        handleSearchChange,
        onSearchKeyHandler,
        handleSearchBy,
        searchBy,
    } = useLiveDataTableCard();

    const [isShow, setIsShow] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [isView, setIsView] = useState(false)

    // const [removeRequest] = useRemoveCompanyMutation()
    // const [statusRequest] = useChangeStatusCompanyMutation()

    console.log('perPage', perPage)
    const {
        data: data2,
        isFetching,
        refetch
    } = useGetPermitsQuery({ pagination: `?page=${currentPage}&per_page=${perPage}&search_by=${searchBy}&search=${q}` })
    const permits = data2?.response?.data?.data
    const total = data2?.response?.data?.total;


    // console.log('af', total)


    const handleAdd = () => {
        setIsEdit(null)
        setIsShow(true)
        // reset()
    }

    const handleEdit = (items) => {
        setIsEdit(items)
        setIsShow(true)
    }

    const handleView = (items) => {
        setIsEdit(items)
        setIsView(true)
    }
    const data = [
        {
            title: 'Company A',
            link: 'https://google.com',
            description: 'lorem lipsum lorem lipsum lorem lipsum lorem lipsum ',
            created_at: '22-04-2025',
        },
    ];

    // const data = [];

    return (
        <>
            <PageHeader name="Permits & Reports" />
            <div className="main-container container-fluid">
                {" "}
                {/* Start::row-1 */}
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card custom-card">
                            <div className="card-header w-100">
                                <div className="row w-100 m-0">
                                    {/*<div className="col-auto p-0 d-flex">
                                        <Button
                                            className="btn btn-primary"
                                            onClick={handleAdd}
                                        >
                                            Add Permits
                                        </Button>
                                    </div>*/}
                                    <div className="col-auto p-0 d-flex ms-2">
                                        <Button
                                            className="btn btn-primary"
                                            onClick={() => refetch()}
                                        >
                                            Refresh
                                        </Button>
                                    </div>
                                    {/*<div className="col-auto ms-auto">
                                        <button className="btn bg-light text-capitalize">
                                            Search By: <span className='text-success'>{searchBy?.split('_')?.join(' ')?.replace('full name', 'driver name')}</span>
                                        </button>
                                    </div>
                                    <div className="col-lg-3 col-5 p-0">
                                        <div className="input-group m-0">
                                            <input
                                                className="form-control" type="text" placeholder="Search Here..."
                                                aria-describedby="basic-addon1"
                                                value={searchQuery}
                                                onKeyUp={(e) => onSearchKeyHandler(e)}
                                                onChange={(e) => setSearchQuery(e.target?.value)}
                                            />
                                            <span
                                                type="button"
                                                onClick={() => handleSearchChange(searchQuery)}
                                                className="input-group-text bg-transparent border text-primary" id="basic-addon1">
                                                <i className="ri-search-line" />
                                            </span>
                                        </div>
                                    </div>*/}
                                </div>
                            </div>
                            <div className="card-body">
                                <div class="row g-4">
                                    {(permits?.length > 0 && !isFetching) ? (
                                        <>
                                            {permits?.map((item, index) => (
                                                <div class="col-lg-4" key={index}>
                                                    <div class="card position-relative border h-100 mb-0">
                                                        <div class="position-absolute"
                                                            style={{
                                                                top: 5,
                                                                right: 12,
                                                                zIndex: 10,
                                                            }}
                                                        >
                                                            <i className="fa fa-eye text-primary" type="button" onClick={() => handleView(item)} />
                                                        </div>
                                                        <div class="card-body">
                                                            <div class="row mb-2 mt-2">
                                                                <div class="col-auto">
                                                                    <span style={{ fontWeight: 'bold' }}>Title:</span>
                                                                </div>
                                                                <div class="col px-0 overflow-hidden">
                                                                    <p class="text-capitalize text-truncate fw-bold text-primary mb-0">{item?.title}</p>
                                                                </div>
                                                            </div>
                                                            <div class="row mb-2">
                                                                <div class="col-12">
                                                                    <span style={{ fontWeight: 'bold' }}>Description:</span>
                                                                </div>
                                                                <div class="col-12 mt-1">
                                                                    <p class="text-capitalize">
                                                                        {item?.description}&nbsp;
                                                                        {item?.description?.length > 10 && (
                                                                            <a href={item?.link || void (0)} target="_blank"
                                                                                className="text-primary text-decoration-underline">
                                                                                view more
                                                                            </a>
                                                                        )}
                                                                    </p>
                                                                </div>
                                                            </div>


                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </>
                                    ) : ''}

                                </div>
                                <div class="only-show-pagination mt-3">
                                    <CustomPagination
                                        isFetching={isFetching}
                                        data={permits}
                                        total={total}
                                        onChangePage={handlePageChange} // Handle page change
                                        onChangeRowsPerPage={handlePerPageChange} // Handle per page change
                                        paginationDefaultPage={currentPage} // Set the current page
                                        paginationRowsPerPageOptions={[9, 12, 18]} // Options for rows per page
                                    />
                                </div>
                            </div>
                        </div>

                        {isShow && (
                            <AddCompanyModal
                                show={isShow}
                                handleClose={() => {
                                    setIsShow(false)
                                    setIsEdit(null)
                                }}
                                isEdit={isEdit}
                            />
                        )}

                        {isView && (
                            <ViewModal
                                show={isView}
                                handleClose={() => {
                                    setIsView(false)
                                    setIsEdit(null)
                                }}
                                isEdit={isEdit}
                            />
                        )}

                    </div>
                </div>
            </div>
        </>
    );
};

export default PermitsPage;